import { render, staticRenderFns } from "./Listbank.vue?vue&type=template&id=34e96c53&"
import script from "./Listbank.vue?vue&type=script&lang=js&"
export * from "./Listbank.vue?vue&type=script&lang=js&"
import style0 from "./Listbank.vue?vue&type=style&index=0&id=34e96c53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports